import { CustomerVoucherType } from 'src/entities/customer/CustomerVoucher';

/** Voucher echoed by the cart calculation response (seam per op_293/429 D-U5-1). */
export default class AppliedVoucher {
    public readonly code: string;
    public readonly title: string;
    public readonly type: CustomerVoucherType;
    public readonly discountAmount: number;

    constructor(json: any) {
        this.code = json.code;
        this.title = json.title;
        this.type = json.type;
        this.discountAmount = json.discountAmount ?? 0;
    }
}
